// Flattened/annotated downloads are always a merged PDF regardless of the
// source document's type, so the original filename's extension (e.g. .jpg)
// has to be swapped for .pdf rather than reused.
export function toPdfFilename(name) {
  const base = (name ?? "document").replace(/\.[a-z0-9]+$/i, "");
  return `${base}.pdf`;
}

// Shared by DocumentCardMenu.vue and DownloadOnlyModal.vue — both need to
// turn a base64 payload from downloadDocument() into a real file download.
export function downloadBase64File(base64, mimeType, filename) {
  const raw = base64.includes(",") ? base64.split(",").pop() : base64;
  const byteChars = atob(raw);
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
  const blob = new Blob([bytes], { type: mimeType || "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
